export const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const EMAIL_OUTLOOK_REGEX = /^[<](([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))[>]$/;
type optionsPropertyObj = 'key' | 'label';

export type GenericOptionsInterface = {
  [x in optionsPropertyObj]: string;
};

/*
  Function that detects the email user input:
  if it selects from the available options then, it's considered valid
  otherwise the string is validated with the EMAIL_REGEX
*/
export const validateFreeTypeEmail = (email: string | GenericOptionsInterface) => {
  return typeof email === 'string' ? EMAIL_REGEX.test(email) : true;
};

/*
  Function that filters the array by the EMAIL_REGEX and EMAIL_OUTLOOK_REGEX
  if the current string matches the EMAIL_OUTLOOK_REGEX, then we remove the
  first and last character (<>)
*/
export const validateFreeTypeEmailArray = (emails: string[]) => {
  return emails
    .filter((email) => EMAIL_REGEX.test(email) || EMAIL_OUTLOOK_REGEX.test(email))
    .map((filteredEmails) => {
      if (EMAIL_OUTLOOK_REGEX.test(filteredEmails)) {
        return filteredEmails.substring(1, filteredEmails.length - 1);
      }
      return filteredEmails;
    });
};
